import React from "react";
import styles from "./HowItWorks.module.css";
function HowItWorksStep({ stepNumber, stepHeader, stepText, stepIcon }) {
  return (
    <div className={styles.Step}>
      {stepIcon && <div className={styles.Icon}>{stepIcon}</div>}
      <div className={styles.StepContent}>
        <div className={styles.StepNumber}>STEP {stepNumber}</div>
        <div className={styles.StepHeader}>{stepHeader}</div>
        <div className={styles.StepText}>{stepText}</div>
      </div>
    </div>
  );
}

export default HowItWorksStep;
